export enum DataHooks {
  Title = 'section-header-title',
  CollapsibleTitle = 'section-header-collapsible-title',
  Divider = 'section-header-divider',
}
